import { atomFactory } from '@utils/recoil/atomFactory';
import { RECOIL_KEYS } from '@utils/constants';

export type NavigationContext = (() => void) | undefined;

export const {
    atom: reactNativeNavigationContextAtom,
    hook: useReactNativeNavigationContextAtom,
} = atomFactory<NavigationContext>({
    key: RECOIL_KEYS.REACT_NATIVE_NAVIGATION_CONTEXT,
    default: undefined,
});
